import { Component } from 'react';
import { node, func } from 'prop-types';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.clearError = this.clearError.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.warn(error, errorInfo);
  }

  clearError() {
    this.setState({ hasError: false });
  }

  render() {
    const { state, props } = this;
    const { hasError } = state;
    const { fallback, children } = props;
    if (hasError) {
      return fallback({ clearError: this.clearError });
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: node.isRequired,
  fallback: func,
};

ErrorBoundary.defaultProps = {
  fallback: () => {},
};

export default ErrorBoundary;
